export enum LogType {
  Request = 'Request',
  Failure = 'Failure',
  Exception = 'Exception',
  SlowestRequest = 'SlowestRequest',
}
